/**
 * Extrait un message lisible depuis `detail` (FastAPI / loyalty API).
 */
export function loyaltyApiDetail(detail) {
    if (detail == null) return null;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((item) => {
                if (typeof item === "string") return item;
                if (item?.msg) return item.msg;
                return JSON.stringify(item);
            })
            .join(" ");
    }
    if (typeof detail === "object") {
        return detail.message || detail.detail || JSON.stringify(detail);
    }
    return String(detail);
}

/**
 * Traduit les messages API loyalty courants (souvent en anglais) en français.
 * Retourne null si aucune traduction connue.
 */
export function translateLoyaltyApiMessage(detail) {
    const raw = loyaltyApiDetail(detail);
    if (!raw) return null;
    const text = raw.toLowerCase();

    if (text.includes("segment") && text.includes("name") && (text.includes("already exists") || text.includes("duplicate"))) {
        return "Un segment portant ce nom existe déjà pour cette marque. Choisissez un autre nom.";
    }
    if (text.includes("rule") && text.includes("name") && text.includes("already exists")) {
        return "Une règle portant ce nom existe déjà. Choisissez un autre nom.";
    }
    if (text.includes("reward") && text.includes("already exists")) {
        return "Une récompense similaire existe déjà. Modifiez le nom ou la description puis réessayez.";
    }
    if (text.includes("coupon") && text.includes("already exists")) {
        return "Un type de coupon portant ce nom existe déjà. Choisissez un autre nom.";
    }
    if (text.includes("tier") && text.includes("already exists")) {
        return "Un palier portant ce nom existe déjà. Choisissez un autre nom.";
    }
    if (text.includes("transaction type") && text.includes("already exists")) {
        return "Un type de transaction portant cette clé existe déjà.";
    }
    if (text.includes("internal job") && text.includes("already exists")) {
        return "Un job interne portant ce nom existe déjà. Choisissez un autre nom.";
    }
    if (text.includes("product") && text.includes("already exists")) {
        return "Un produit portant ce nom ou cette référence existe déjà.";
    }
    if (text.includes("already exists") || text.includes("duplicate")) {
        return "Cet élément existe déjà. Modifiez les valeurs saisies puis réessayez.";
    }
    if (text.includes("not found")) {
        return "Élément introuvable. Rechargez la page ou vérifiez l'identifiant.";
    }
    if (text.includes("permission") || text.includes("forbidden") || text.includes("not allowed")) {
        return "Action non autorisée pour votre compte ou cette marque.";
    }
    if (text.includes("invalid") && text.includes("json")) {
        return "JSON invalide. Vérifiez la syntaxe du champ concerné.";
    }

    return null;
}

/** Message utilisateur : traduction FR si connue, sinon texte API brut. */
export function loyaltyUserMessage(detail, fallback = null) {
    return translateLoyaltyApiMessage(detail) || loyaltyApiDetail(detail) || fallback;
}
